module.exports = __webpack_public_path__ + "img/1229_sprites_bundesliga.bcde98d8.png";